import React, {Component, createRef} from 'react';
import * as settings from "../search/settings";

export default class Modal extends Component {
    constructor(props) {
        super(props);

        this.modalContentRef = createRef();

        this.state = {
            isActive: this.props.isActive,
            data: this.props.modalContent,
            hasScrollbar: this.props.hasScrollbar != null ? this.props.hasScrollbar : true
        };

        this.closeModal = this.closeModal.bind(this);
        this.updateScrollbar = this.updateScrollbar.bind(this);
    }

    componentDidMount() {
        if(this.state.hasScrollbar) {
            // Add a custom scrollbar for modal content
            this.scrollbar = new PerfectScrollbar(
                this.modalContentRef.current,
                settings.scrollbarOptions
            );
        }
    }

    componentDidUpdate(prevProps) {
        if(this.state.hasScrollbar) {
            this.updateScrollbar();
        }

        // Allow for setting modal visibility from parent component
        if(prevProps.isActive !== this.props.isActive
            && this.props.isActive !== this.state.isActive) {
            this.setState({
                isActive: this.props.isActive,
            });
        }
    }

    closeModal() {
        this.setState({
            isActive: false,
        });

        // Send feedback to parent if needed
        if(this.props.setModalActive) {
            this.props.setModalActive(false);
        }

        this.props.onCloseCallback ? this.props.onCloseCallback() : null;
    }

    updateScrollbar() {
        this.scrollbar.element.scrollTop = 0;
        this.scrollbar.update();
    }

    render() {
        let modalContent;

        if(this.props.modalContent) {
            modalContent = this.props.modalContent;
        } else {
            modalContent = (
                <div className="loader--full-screen">
                    <div className="loader__icon"/>
                </div>
            );
        }

        return (
            <aside className={this.props.className + " modal-component" + (this.state.isActive ? " modal-active" : "")}
                   role="dialog"
                   aria-hidden={!this.state.isActive}>
                <div className="modal-component__box"
                     role="region"
                     aria-live="polite">
                    <button className="modal-component__close"
                            aria-label="Close modal"
                            onClick={this.closeModal} />
                    <div className={"modal-component__content " +
                                    (this.props.hasLargeContent ? "modal-component__content--large" : "")}
                         ref={this.modalContentRef}>
                        {modalContent}
                    </div>
                </div>
                <div className="modal-component__bg"
                     onClick={this.closeModal} />
            </aside>
        );
    }
}
